import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { AssignmentAvailabilityStatus } from '@wilson/interfaces';
import { TimelineModalFilterService } from '../../../services/timeline-modal-filter.service';

@Component({
  selector: 'wilson-user-activity-assignment-availability-filter',
  imports: [CommonModule, NzSelectModule, FormsModule, TranslateModule],
  templateUrl: './user-activity-assignment-availability-filter.component.html',
  styleUrls: ['./user-activity-assignment-availability-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserActivityAssignmentAvailabilityFilterComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  AssignmentAvailabilityStatus = AssignmentAvailabilityStatus;

  availableStaffChanged(staffAvailability: AssignmentAvailabilityStatus) {
    this.timelineModalFilterService.staffAvailabilityChanged(staffAvailability);
    this.cdRef.detectChanges();
  }
}
